import da from './locale_da';
import en from './locale_en';
import es from './locale_es';
import fi from './locale_fi';
import no from './locale_no';
import sv from './locale_sv';

const charityLanguages = [ 'en', 'sv', 'no' ];
const insuranceLanguages = [ 'en', 'sv', 'sv-fi', 'fi', 'no', 'es' ];

const locales = {
  da: { translations: da },
  en: { translations: en },
  es: { translations: es },
  fi: { translations: fi },
  no: { translations: no },
  sv: { translations: sv }
};

charityLanguages.forEach((locale) => {
  locales[`${locale}-x-charity`] = locales[locale];
});

insuranceLanguages.forEach((locale) => {
  if (locales[locale]) {
    locales[`${locale}-x-insure`] = locales[locale];
  }
});

export default locales;
